import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Redirect, Route, Switch} from 'react-router';
import config from 'config';
import './index.css';

import {AuthComponent, Permissions} from 'components/ComponentSecurity';

import {addNotification as addNotificationAction} from 'services/notification/action';
import Header from './components/header';
import SideNav from './components/side-bar/SideNav';
import Index from './components/management/index';
import Chat from './components/chat';
import Graph from './components/graph/Graph';
import {fetchCompanyRequested} from '../../services/company/action';
import {getUserDataRequested} from '../../services/user/action';
import LoadingComponent from '../../assets/LoadingComponent';
import Billing from "./components/billing";
import MyHistory from "./components/my-history/MySpace";

class Dashboard extends React.Component {
    componentDidMount() {
        const {fetchCompany, getUserData, user} = this.props;
        if (user.isAuthenticated) {
            fetchCompany();
            getUserData();
        }
    }

    render() {
        const {
            user, match, company, addNotification,
        } = this.props;

        const {tariff} = company;
        const {features} = company.tariff;

        let matchUrl = match.url;
        if (matchUrl === '/') {
            matchUrl = '/dashboard';
        }

        if (!user.isAuthenticated) {
            window.location.href = config.APP_HOST + "/login"
        }

        if (!user.initialInfoFetched || !company.initialInfoFetched) {
            return <LoadingComponent/>;
        }

        const defaultProps = {
            user,
            addNotification,
            company,
        };


        return (
            <div className="dashboard full-height">
                <Header user={user} company={company}/>
                <Permissions user={user} component={SideNav} company={company}/>
                <main className="full-height">
                    <Switch>
                        {(tariff.status === config.tariffStatusMap.active || tariff.status === config.tariffStatusMap.trial) &&
                            <Route
                                path={`${matchUrl}/chat/:id`}
                                render={props => (
                                    <AuthComponent {...defaultProps} requiredPermission={config.permissions.any}
                                                   component={Chat} {...props} />)}
                            />
                        }

                        {(tariff.status === config.tariffStatusMap.active || tariff.status === config.tariffStatusMap.trial) &&
                            (features.includes(config.features.MY_HISTORY) || features.includes(config.features.TICKETS)) &&
                            <Route
                                path={`${matchUrl}/my/space`}
                                render={props => (
                                    <AuthComponent {...defaultProps} requiredPermission={config.permissions.any}
                                                   component={MyHistory} {...props} />)}
                            />
                        }
                        {features.includes(config.features.BILLING) && (
                            <Route
                                path={`${matchUrl}/billing`}
                                render={props => (
                                    <AuthComponent {...defaultProps} requiredPermission={config.permissions.billing}
                                                   component={Billing} {...props} />)}
                            />
                        )}
                        {(tariff.status === config.tariffStatusMap.active
                                || tariff.status === config.tariffStatusMap.trial
                                || tariff.status === config.tariffStatusMap.paymentRequired) &&
                            <Route
                                path={`${matchUrl}/management`}
                                render={props => (
                                    <AuthComponent {...defaultProps} requiredPermission={config.permissions.management}
                                                   component={Index} {...props} />)}
                            />
                        }
                        {(tariff.status === config.tariffStatusMap.active || tariff.status === config.tariffStatusMap.trial) &&
                            <Route path={`${matchUrl}/graph/:clientId`}
                                   render={props => (<AuthComponent {...defaultProps} component={Graph}
                                                                    requiredPermission={config.permissions.any}
                                                                    user={user}
                                                                    tariff={tariff} {...props} />)}/>
                        }
                        {(tariff.status === config.tariffStatusMap.active || tariff.status === config.tariffStatusMap.trial) &&
                            <Route path={`${matchUrl}/`}
                                   render={() => (<Redirect to={`${matchUrl}/chat/${config.platformsMap.company}`}/>)}/>
                        }
                    </Switch>
                </main>
            </div>
        );
    }
}

Dashboard.propTypes = {
    user: PropTypes.shape({
        isAuthenticated: PropTypes.bool.isRequired,
    }).isRequired,
    company: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    fetchCompany: PropTypes.func.isRequired,
    getUserData: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    user: state.user,
    company: state.company,
});

const mapDispatchToProps = dispatch => ({
    fetchCompany: () => {
        dispatch(fetchCompanyRequested());
    },
    getUserData: () => {
        dispatch(getUserDataRequested());
    },
    addNotification: (message, level, notificationConfig) => {
        dispatch(addNotificationAction(message, level, notificationConfig));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/index.jsx